import React from "react";
import { utils, writeFile } from "xlsx-js-style";
import { useLocation } from "react-router-dom";
import CustomInput from "../components/formik/CustomInput";
import {
  ServiceBackground,
  ServiceConact,
} from "../components/reports/ServiceColumn";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import {
  getComission,
  getComissionPerCrane,
  getComissionPerKM,
  getCurrentFortnight,
  getCurrentFortnightName,
  getOrderType,
  getReason,
} from "../models/ReportOperatorSalary";
import CustomSelect from "../components/formik/CustomSelect";
import { useOrderVialContext } from "../context/OrderVialContext";

const calculateCommissionBySubtotal = (subtotal, priceRanges) => {
  if (!subtotal || subtotal <= 0 || !Array.isArray(priceRanges))
    return { commission: 0, percentage: 0 };

  const range = priceRanges.find(
    (r) => subtotal >= r.minimo && (r.maximo === null || subtotal <= r.maximo)
  );

  if (!range) return { commission: 0, percentage: 0 };

  const commission = (subtotal * range.porcentaje) / 100;
  return {
    commission: parseFloat(commission.toFixed(2)),
    percentage: range.porcentaje,
  };
};

const NewOperatorSalaryFormGruas = ({
  formik,
  records,
  operators,
  status,
  priceRanges = [],
}) => {
  const baseUrl = window.location.origin;

  const exportToExcel = () => {
    const workbook = utils.book_new();

    records
      .filter((record) => record?.orders?.length > 0)
      .map((operator) => {
        const sheetName =
          `${operator.operador.name} ${operator.operador.first_surname} ${operator.operador.second_surname}`.substring(
            0,
            30
          );

        const sheetData = [
          [
            "Folio",
            "Descripción del servicio",
            "Tipo de Servicio",
            "Fecha",
            "Total (Sin IVA)",
            "KM aproximados",
            "Grúa",
            "Tipo de grúa",
            "Razón",
          ],
        ];

        let totalSubtotal = 0;
        let totalDistanceSum = 0;

        operator.orders.map(({ Order, totalDistance }) => {
          const orderType =
            Order.tipoServicio != null
              ? Order.tipoServicio
              : getOrderType(Order);

          const bg = ServiceBackground({ row: Order });

          const reason = Order.razon?.trim() ? Order.razon : getReason(Order);

          const subtotal = Order.orden_en_cero
            ? 0
            : Number(Order.subtotal) || 0;

          totalSubtotal += subtotal;
          totalDistanceSum += Number(totalDistance) || 0;

          sheetData.push([
            {
              t: "s",
              v: Order.folio.toString().padStart(5, "0"),
              l: {
                Target:
                  Order.tipo === "Varo Express"
                    ? `${baseUrl}/orders-vial/editOrder/${Order.id}`
                    : `${baseUrl}/orders/edit/${Order.id}`,
              },
              s: { fill: { fgColor: { rgb: bg } } },
            },
            {
              t: "s",
              v: orderType,
              s: { fill: { fgColor: { rgb: bg } } },
            },
            {
              t: "s",
              v: ServiceConact({ row: Order }),
              s: { fill: { fgColor: { rgb: bg } } },
            },
            {
              t: "s",
              v: format(new Date(Order.fecha_hora_reporte), "dd/MMM/yyyy", {
                locale: es,
              }),
              s: { fill: { fgColor: { rgb: bg } } },
            },
            {
              t: "n",
              v: subtotal,
              s: { fill: { fgColor: { rgb: bg } } },
            },
            {
              t: "n",
              v: Number(totalDistance).toFixed(2),
              s: { fill: { fgColor: { rgb: bg } } },
            },
            {
              t: "s",
              v: Order?.Crane?.description || "",
              s: { fill: { fgColor: { rgb: bg } } },
            },
            {
              t: "s",
              v: Order?.Crane?.CraneTypes?.at(0)?.crane_type_name || "",
              s: { fill: { fgColor: { rgb: bg } } },
            },
            {
              t: "s",
              v: reason,
              s: { fill: { fgColor: { rgb: bg } } },
            },
          ]);
        });

        // Calcular comisión total y porcentaje según el subtotal acumulado
        const { commission, percentage } = calculateCommissionBySubtotal(
          totalSubtotal,
          priceRanges
        );

        sheetData.push([{ t: "s", v: "" }]); // línea vacía

        sheetData.push([
          { t: "s", v: "Total" },
          { t: "s", v: "" },
          { t: "s", v: "" },
          { t: "s", v: "" },
          { t: "n", v: totalSubtotal.toFixed(2) },
          { t: "s", v: "" },
          {
            t: "s",
            v:
              `Comisión ${percentage}%` +
              " " +
              "(" +
              commission.toFixed(2) +
              ")",
            s: { alignment: { horizontal: "left" } },
          },
        ]);

        const worksheet = utils.aoa_to_sheet(sheetData);
        worksheet["!cols"] = [
          { wch: 20 },
          { wch: 35 },
          { wch: 20 },
          { wch: 30 },
          { wch: 20 },
          { wch: 20 },
          { wch: 20 },
          { wch: 35 },
          { wch: 35 },
        ];

        utils.book_append_sheet(workbook, worksheet, sheetName);
      });

    writeFile(workbook, getCurrentFortnightName() + ".xlsx");
  };

  return (
    <React.Fragment>
      <div className="row">
        <div className="row">
          <CustomInput
            label="Fecha inicio"
            field="start"
            type="date"
            formik={formik}
            sm={2}
          />
          <CustomInput
            label="Fecha fin"
            field="end"
            type="date"
            formik={formik}
            sm={2}
          />

          <CustomSelect
            label="Operadores"
            field="operator"
            formik={formik}
            options={operators}
            required
            sm={2}
          />

          <CustomSelect
            label="Estatus orden"
            field="status"
            formik={formik}
            options={status}
            required
            sm={2}
          />
          <div className="col-md-4">
            <div
              style={{
                display: "flex",
                gap: 10,
                justifyContent: "end",
                marginTop: 20,
              }}
            >
              <button
                className="btn btn-primary btn-lg"
                onClick={() => formik.handleSubmit()}
              >
                <i class="fa-solid fa-magnifying-glass" />
                &nbsp;Buscar
              </button>
              <button
                className="btn btn-success btn-lg"
                onClick={() => exportToExcel()}
              >
                <i class="fa-solid fa-file-excel" />
                &nbsp;Descargar
              </button>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default NewOperatorSalaryFormGruas;
